/*
 * 苏州海管家物流科技有限公司（https://www.hgj.com/）.
 * 苏公网安备32059002003385号 © 2015-2023 Hgj.com All Rights Reserved. | 苏ICP备15030950号.
 * @Date: 2023.09.05.
 * @Author
 * @Description 恪保 - 常数、数组、对象 定义 工具类中使用.
 **/
/**
 *@Description 请求方式.
 *@Return .
 **/
export enum E_HTTP_METHOD {
  GET = 'GET', // get resource
  PUT = 'PUT', // update resource
  POST = 'POST', // create new resource
  FORM = 'FORM', // push by form
  PATCH = 'PATCH',
  DELETE = 'DELETE', // delete resource
  OPTIONS = 'OPTIONS',
}
